export function compareClientVersions(current: string, minimum: string) {
  const currentParts = parseVersion(current);
  const minimumParts = parseVersion(minimum);
  const maxLength = Math.max(currentParts.length, minimumParts.length);

  for (let index = 0; index < maxLength; index += 1) {
    const currentPart = currentParts[index] ?? 0;
    const minimumPart = minimumParts[index] ?? 0;

    if (currentPart > minimumPart) {
      return 1;
    }
    if (currentPart < minimumPart) {
      return -1;
    }
  }

  return 0;
}

function parseVersion(version: string) {
  return version
    .split(".")
    .map((part) => Number.parseInt(part, 10))
    .map((part) => (Number.isNaN(part) ? 0 : part));
}
